import Vue from "vue";

const DEFAULT_CONFIG = {
  requiresConsent: false,
  consentUrl: "",
  consentEmail: "",
  consentStorageKey: "",
  consentTitle: "",
  consentBody: "",
  consentCheckboxText: "",
  isFreeDigital: false,
  isHeadshot: false,
  galleryMode: "snapshot",
  printsEnabled: true,
  faceSearchRecommended: true,
  consentMode: "none",
  ceremonyLabelOnly: false,
  pricingTier: "uk",
  rememberMeEnabled: true,
  saveSelfieEnabled: false,
  rememberMeTtlDays: 30,
  newImagesTtlDays: 7,
  saveSelfieConsentVersion: "v1",
  saveSelfieConsentPolicyUrl: "/privacy-policy",
  saveSelfieConsentOrgName: "MyGraduationClip",
};

const CONFIG_BY_SLUG = {
  ucd: {
    requiresConsent: true,
    consentUrl:
      "https://www.ucd.ie/alumni/development-and-alumni-relations-privacy-policy/",
    consentEmail: "alumni@ucd.ie",
    consentStorageKey: "consent:ucd-headshots:v1",
    isFreeDigital: true,
    isHeadshot: true,
    galleryMode: "headshot",
    printsEnabled: false,
    consentMode: "ucd_daro",
    ceremonyLabelOnly: true,
  },
  "ucd-test": {
    requiresConsent: true,
    consentUrl:
      "https://www.ucd.ie/alumni/development-and-alumni-relations-privacy-policy/",
    consentEmail: "alumni@ucd.ie",
    consentStorageKey: "consent:ucd-headshots:v1",
    isFreeDigital: true,
    isHeadshot: true,
    galleryMode: "headshot",
    printsEnabled: false,
    consentMode: "ucd_daro",
    ceremonyLabelOnly: true,
  },
  adelaide: {
    pricingTier: "aud",
  },
  "torrens-test": {
    pricingTier: "aud",
  },
  "gfpevents-test-uni": {
    pricingTier: "aud",
    saveSelfieEnabled: true,
    saveSelfieConsentOrgName: "GFP Events",
  },
};

export const snapshotConfigState = Vue.observable({
  bySlug: {},
});

export const setRuntimeSnapshotConfig = (slug, config) => {
  const key = String(slug || "").toLowerCase();
  if (!key || !config) return;
  Vue.set(snapshotConfigState.bySlug, key, config);
};

export const getSnapshotConfig = (slug) => {
  const key = String(slug || "").toLowerCase();
  const base = {
    ...DEFAULT_CONFIG,
    consentStorageKey: key ? `consent:${key}:v1` : "",
  };
  const config = {
    ...base,
    ...(CONFIG_BY_SLUG[key] || {}),
    ...(snapshotConfigState.bySlug[key] || {}),
  };
  if (!config.galleryMode || config.galleryMode === "snapshot") {
    config.galleryMode = config.isHeadshot ? "headshot" : "snapshot";
  }
  config.isHeadshot = config.galleryMode === "headshot";
  return config;
};
